import React, { useState, useEffect, useRef } from 'react';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import { Container, Row, Col, Table, Form, Button, Tabs, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import * as Picklist from "../Picklist";
import * as Common from "../Common";
import $ from "jquery";
import Master_individual_profile from '../master/Master_individual_profile';
import FaView from '../FaView';
import ActivityLog from '../ActivityLog';
import Tran_data_unlock_request from '../Tran_data_unlock_request';

const Tran_principle_module = () => {

    const paymentRef = useRef();
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");

    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("");

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("")
    const [isErrBox, setErrBox] = useState(false);
    const [errText, setErrText] = useState("");

    const [srno, setSrno] = useState(0);
    const [principleData, setPrincipleData] = useState([]);
    const [radioType, setRadioType] = useState('N');
    const [pmLocation, setPmLocation] = useState(null);
    const [pmFromSrno, setPmFromSrno] = useState('');
    const [pmToSrno, setPmToSrno] = useState('');
    const [pmFromDate, setPmFromDate] = useState(new Date());
    const [pmToDate, setPmToDate] = useState(new Date());
    const [pmNewDate, setPmNewDate] = useState(new Date());
    const [pmPrinciple, setPmPrinciple] = useState(null);
    const [pmRefNum, setPmRefNum] = useState('');
    const [pmAmount, setPmAmount] = useState(0);
    const [pmOtherCharges, setPmOtherCharges] = useState(0);
    const [pmInvAmount, setPmInvAmount] = useState(0);
    const [locationCode, setLocationCode] = useState(0);
    const [principleCode, setPrincipleCode] = useState(0);
    const [principleFlag, setPrincipleFlag] = useState('');
    const [showIndividualForm, setShowIndividualForm] = useState(false);
    const [nIndividual, setNIndividual] = useState(null);
    const [nIndividualSrno, setNIndividualSrno] = useState(0);
    const [scrIndividual, setScrIndividual] = useState("");
    const [nIndividualIdSrno, setNIndividualIdSrno] = useState(0);
    const [pdAccount, setPdAccount] = useState(null);
    const [pdPaymentType, setPdPaymentType] = useState("");
    const [pdAmount, setPdAmount] = useState("");
    const [key, setKey] = useState("INFO");
    const [pdAccountValue, setPdAccountValue] = useState("");
    const [pdGroupValue, setPdGroupValue] = useState(0);
    const [pdChequeNum, setPdChequeNum] = useState("");
    const [paymentData, setPaymentData] = useState([]);
    const [ldgSrchType, setLdgSrchType] = useState("");
    const [chequeValue, setChequeValue] = useState("");
    const [disablePaymentAccount, setDisablePaymentAccount] = useState(true);
    const [chequeLocation, setChequeLocation] = useState(0);
    const [chequeLineNo, setChequeLineNo] = useState(0);
    const [chequeSrno, setChequeSrno] = useState(0);
    const [chequeNum, setChequeNum] = useState(0);
    const [counter, setCounter] = useState(0);
    const [paymentLineNo, setPaymentLineNo] = useState(0);
    const [randomString, setRandomString] = useState("");
    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });

    const [showFaView, setShowFaView] = useState(false);
    const [principleName, setPrincipleName] = useState("");
    const [nIndivudualName, setNIndividualName] = useState("");
    const [pmViewDate, setPmViewDate] = useState("");
    const [pmOrderNum, setPmOrderNum] = useState("");
    const [pmSenderName, setPmSenderName] = useState("");
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [compareData, setCompareData] = useState([]);

    const [viewDate, setViewDate] = useState(new Date());
    const [viewSrno, setViewSrno] = useState(0);
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [ldgAllBank, setLdgAllBank] = useState(null);
    const [ldgAllBankCode, setLdgAllBankCode] = useState("");
    const [nAccountNo, setNAccountNo] = useState("");
    const [nIfscCode, setNIfscCode] = useState("");
    const [individualIdType, setIndividualIdType] = useState("");
    const [nCountryOfIssue, setNCountryOfIssue] = useState("0");
    const [indPan, setIndPan] = useState("");
    const [usdRate, setUsdRate] = useState(0);
    const [usdAmount, setUsdAmount] = useState('0');
    const [nationalityCode, setNationalityCode] = useState("0");
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setPmLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'PRINCIPLE_MODULE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    const handleChangeLocation = (value) => {
        setPmLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setIsBranchDisableForAddNew(loc[9]);
    }


    const handleChangePrinciple = (value) => {
        console.log("Principle Data is :", value);
        setPmPrinciple(value);
        const principle = value.id.split('^');
        setPrincipleCode(principle[1]);
        setPrincipleName(principle[3]);
        setPrincipleFlag(principle[4]);
        if (principle[4] === 'S') {
            setPmInvAmount((1 * pmAmount) + (1 * pmOtherCharges));
        } else if (principle[4] === 'P') {
            setPmInvAmount((1 * pmAmount) + (-1 * pmOtherCharges));
        }
    }


    const addNew = () => {
        var d = Common.dateYMD(pmNewDate);
        var today = Common.dateYMD(new Date());
        if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (pmLocation === null) {
            setMsgText("Please Select Location. ");
            setMsgBox(true);
        } else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        } else {
            if (d == today) {
                resetAddNewForm();
            } else {
                const obj = {
                    billdate: d,
                    location: locationCode,
                    type: "MT"
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (+resp.msg === 1) {
                        resetAddNewForm();
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }
    function resetAddNewForm() {
        setSrno(0);
        setScrMode('A');
        setPmPrinciple(null);
        setNIndividual(null);
        setPmRefNum('');
        setPmAmount('');
        setPmOtherCharges(0);
        setPmInvAmount(0);
        setPaymentData([]);
        setKey('INFO');
        setPmViewDate("");
        setPmOrderNum("");
        setPmSenderName("");
        setNationalityCode("0");
        Common.callApi(Common.apiPrincipleModule, [sid, 'getlastestrate'], function (result) {
            let result1 = JSON.parse(result);
            let rate = Number(parseFloat(result1).toFixed(2));
            setUsdRate(rate);
        });
    }


    const list = () => {
        var msg = [], i = 0;
        $(".loader").show();
        if (pmLocation === null) {
            $(".loader").hide();
            setMsgText("Please Select Location!");
            setMsgBox(true);
        } else if ((radioType === 'S' && (pmFromSrno === "" || pmToSrno === "")) || (radioType === 'D' && (!pmFromDate || !pmToDate))) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (radioType === 'S' && pmFromSrno === "" ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && pmToSrno === "" ? " To Srno." : '');
            msg[i++] = (radioType === 'D' && !pmFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !pmToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                location: locationCode,
                type: 'MT',
                filterRadioType: radioType,
                filterFromDate: Common.dateYMD(pmFromDate),
                filterToDate: Common.dateYMD(pmToDate),
                filterFromSrno: pmFromSrno,
                filterToSrno: pmToSrno,
            }
            Common.callApi(Common.apiPrincipleModule, [sid, 'list', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                console.log("Principle Data is ", resp);
                setPrincipleData(resp);
            });
        }
    }


    const handleAmount = (e) => {
        Common.validateDecValue(e.target.value, setPmAmount);
        if (principleFlag === 'S') {
            setPmInvAmount((1 * e.target.value) + (1 * pmOtherCharges));
        }
        if (principleFlag === 'P') {
            setPmInvAmount((1 * e.target.value) + (-1 * pmOtherCharges));
        }
    }


    const handleOtherCharges = (e) => {
        Common.validateDecValue(e.target.value, setPmOtherCharges);
        if (principleFlag === 'S') {
            setPmInvAmount((1 * e.target.value) + (1 * pmAmount));
        }
        if (principleFlag === 'P') {
            setPmInvAmount((-1 * e.target.value) + (1 * pmAmount));
        }
    }


    const saveData = () => {
        $(".loader").show();
        var msg = [], i = 0;
        var totalinr = 0;

        for (var k = 0; k < paymentData.length; k++) {
            if (paymentData[k].tp_payment_type === "PB") //RC
                totalinr -= paymentData[k].tp_amount * 1;
            else totalinr += paymentData[k].tp_amount * 1;
        }
        console.log(`total amount is ${pmInvAmount} and totalInr is ${totalinr}`);
        if (pmInvAmount != Math.abs(totalinr)) {
            $(".loader").hide();
            setMsgText("Total amount of payment must be equal to calculated INR.");
            setMsgBox(true);
            i++;
        }
        //check individual is foreigner then passport is mandotory
        console.log("nCountryOfIssue:", nCountryOfIssue, "individualIdType:", individualIdType);
        if (nCountryOfIssue * 1 != 1) {//1=Resident Indian and 1 mean passport
            if (individualIdType * 1 != 1) {
                $(".loader").hide();
                setMsgText('For Foreign Individual, Passport is mandatory.');
                setMsgBox(true);
                i++;
            }
        }

        if (i == 0) {
            if (pmPrinciple === null || nIndividual === null || pmRefNum === "" || pmAmount === "" || pmOtherCharges === "") {
                $(".loader").hide();
                msg[i++] = Common.getMessage("MSG0006");
                msg[i++] = (pmPrinciple === null ? "Select Master Principle." : "");
                msg[i++] = (nIndividual === null ? "Individual Profile." : '');
                msg[i++] = (pmRefNum === '' ? "Reference Number." : "");
                msg[i++] = (pmAmount === '' ? "Amount." : "");
                msg[i++] = (pmOtherCharges === '' ? "Other Charges." : "");
                setMsgText(Common.buildMessageFromArray(msg));
                setMsgBox(true);
            } else if ((paymentData.filter(p => p?.tp_payment_type === 'PB').length >= 1) && (paymentData.length > 1)) {
                setMsgText("Only one payable allowed.");
                setMsgBox(true);
                $(".loader").hide();
            } else if (principleFlag === 'P' && nCountryOfIssue === '1' && indPan === '') {
                setMsgText("PAN is mandatory- for Resident Indian.");
                setMsgBox(true);
                $(".loader").hide();
            } else {
                const obj = {
                    srno: srno,
                    location: locationCode,
                    type: 'MT',
                    // date: Common.dateYMD(pmNewDate),
                    date: srno > 0 ? pmViewDate : Common.dateYMD(pmNewDate),
                    principleFlag: principleFlag,
                    refNum: pmRefNum,
                    amt: pmAmount,
                    othChrgs: pmOtherCharges,
                    invamt: pmInvAmount,
                    nIndividualSrno: nIndividualSrno,
                    nIndividualIdSrno: nIndividualIdSrno,
                    principleCode: principleCode,
                    paymentData: paymentData,
                    randomString: randomString,

                    filterRadioType: radioType,
                    filterFromDate: Common.dateYMD(pmFromDate),
                    filterToDate: Common.dateYMD(pmToDate),
                    filterFromSrno: pmFromSrno,
                    filterToSrno: pmToSrno,
                    individulName: nIndivudualName,
                    principleName: principleName,
                    pmOrderNum: pmOrderNum,
                    pmSenderName: pmSenderName,
                    individualIdType: individualIdType,
                    indPan: indPan,
                    nCountryOfIssue: nCountryOfIssue,
                    usdRate: parseFloat(usdRate).toFixed(2),
                    usdAmount: parseFloat(usdRate) > 0 && parseFloat(pmAmount) > 0 ? (parseFloat(pmAmount) / parseFloat(usdRate)).toFixed(2) : 0
                };
                const infoObject = Common.compareArrays(compareData, [obj]);
                if (userRight.edit === "1" && scrMode === "E") {
                    setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'MT', locationCode));
                }
                Common.callApi(Common.apiPrincipleModule, [sid, 'save', JSON.stringify(obj), JSON.stringify(tranAuditTrail)], (result) => {
                    $(".loader").hide();
                    let resp = JSON.parse(result);
                    if (resp.msg != 'OK') {
                        setMsgText(resp.msg);
                        setMsgBox(true);
                    } else {
                        setPrincipleData(resp.principleArr);
                        setTranAuditTrail([]);
                        setScrMode('');
                    }
                });
            }
        }

    }
    const fillViewCompareObject = (resp) => {
        const desc = resp.corpDesc.split("^")
        const obj2 = {
            principleFlag: resp.principleflag,
            refNum: resp.refNum,
            amt: resp.amt,
            othChrgs: resp.othChrg,
            invamt: resp.invAmt,
            nIndividualSrno: resp.individual,
            nIndividualIdSrno: resp.individualId,
            principleCode: resp.principlecode,
            paymentData: resp.paydetails,
            pmOrderNum: resp.principleOrderNum,
            pmSenderName: resp.pmSenderName,
        };
        setCompareData([obj2]);
    }

    const viewList = (srno, location, type, viewDate) => {
        setKey('INFO');
        setSrno(srno);
        setScrMode('Q');
        setRandomString("0");
        setViewDate(viewDate);
        setViewSrno(srno);
        $(".loader").show();
        const obj = {
            srno: srno,
            location: location,
            type: type,
        };
        Common.callApi(Common.apiPrincipleModule, [sid, 'viewList', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            fillViewCompareObject(resp);
            $(".loader").hide();
            const desc = resp.corpDesc.split("^")
            // if (resp.prnclId === "^0^0^") setPmPrinciple(null);
            // else setPmPrinciple({ id: resp.prnclId, label: resp.prnclLabel });

            if (resp.prnclId === "^0^^") setPmPrinciple(null);
            else setPmPrinciple({ id: resp.prnclId, label: resp.prnclLabel });

            if (resp.ind_id === "^0^0^") setNIndividual(null);
            else setNIndividual({ id: resp.ind_id, label: resp.ind_label, desc: `${desc.slice().join(" ^  ")}` });
            setPmRefNum(resp.refNum);
            setPmAmount(resp.amt);
            setPmOtherCharges(resp.othChrg);
            setPmInvAmount(resp.invAmt);
            setPaymentData(resp.paydetails);
            setPaymentLineNo(resp.paymaxlineno * 1);
            setNIndividualSrno(resp.individual);
            setNIndividualIdSrno(resp.individualId);
            setPmViewDate(resp.dateymd);
            setPrincipleCode(resp.principlecode);
            setPrincipleFlag(resp.principleflag);
            setPmOrderNum(resp.principleOrderNum);
            setPmSenderName(resp.pmSenderName);
            setUsdRate(resp.usdRate);
            setUsdAmount(resp.usdAmount);
        });
    }


    const deletePayment = (value) => {
        const obj = {
            srno: srno,
            location: locationCode,
            type: 'MT',
            payment_line_no: value.tp_line_no
        }
        Common.callApi(Common.apiPrincipleModule, [sid, "shouldDelete", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (srno < 1 || resp.isdeletable == '1') {
                const itemToDelete = paymentData.find(item => item.uniquekey === value.uniquekey);
                if (itemToDelete) {
                    const formattedItem = {
                        TabType: "Payment",
                        ALineNo: tranAuditTrail.length + 1,
                        AType: "D",
                        TLine: paymentLineNo + 1,
                        TLoc: locationCode,
                        TType: 'MT',
                        PaymentType: itemToDelete.tp_payment_type,
                        PaymentGroupCode: itemToDelete.tp_group,
                        PaymentLedgerCode: itemToDelete.tp_account,
                        PaymentAccountName: itemToDelete.mvli_ledger_name,
                        PaymentAmount: itemToDelete.tp_amount,
                        ReferenceNo: itemToDelete.tp_cheque,
                        // } : {}),

                    };
                    if (userRight.edit === "1" && scrMode === 'E') {
                        setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
                    }
                }
                const paymentdata = Common.arrayRemoveItem(paymentData, "uniquekey", value.uniquekey);
                setPaymentData(paymentdata);
                var amt = 0;
                for (var i = 0; i < paymentdata.length; i++) {
                    amt += paymentdata[i].tp_amount * 1;
                }
                setPdAmount(1 * pmInvAmount - amt);
            } else {
                setMsgBox(true);
                setMsgText("Cannot delete, amount aleady knockedoff.");
            }
        });
        setCounter(counter - 1);
    }


    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0];
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        console.log(`Difference Days ${differenceInDays}`);

        const obj = {
            srno: viewSrno,
            type: 'MT',
            pageright: 'PRINCIPLE_MODULE',
            location: locationCode,
        }
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setScrMode('E');
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'MT', trannumber: viewSrno, location: locationCode, trandate: Common.dateYMD(currDate) });
            }
        });

    }


    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }


    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }


    const newIndividual = (btnype) => {
        setShowIndividualForm(true);
        if (btnype === "E" && nIndividual != null) setScrIndividual("E");
        else setScrIndividual("A");
    }


    const handleNewIndiviualChange = (value) => {
        console.log("New Individual Picklist: ", value);
        setNIndividual(value);
        var id = value.id.split("^");
        setNIndividualSrno(id[1]);
        setNIndividualIdSrno(id[2]);
        setNIndividualName(id[3]);
        setIndPan(id[4]);
        setIndividualIdType(id[12]);
        setNCountryOfIssue(id[13]);
        setNationalityCode(id[14]);
    }


    const hideIndividualProfile = (val, individualsrno, blacklistedYN, master, dataid, name, idSrno = 0) => {
        setShowIndividualForm(val);
        if (individualsrno > 0) {
            const obj = {
                individualsrno: individualsrno,
                idSrno: idSrno,
                type: "PRINCIPLE"
            }
            Common.callApi(Common.apiIndividualProfile, [sid, "individualidfrompicklist", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                console.log("RESPONSE IS  ", resp);
                const desc = resp.desc.split("^");
                if (resp.id === "") setNIndividual(null);
                else handleNewIndiviualChange({ ...resp, desc: `${desc.slice().join("  ^  ")}` });
                // `${desc.slice(0, 3).join(" ")} ^ ${desc[3]} ^ ${desc.slice(4, 7).join(" ")}  ^    ${desc[7]}`
            });
        }
    }

    const handlePaymentType = (v) => {
        $(".loader").show();
        setDisablePaymentAccount(false);
        setPdPaymentType(v);
        setPdAccount(null);
        setPdAccountValue(0);
        setPdChequeNum("");
        setLdgAllBank(null);
        setLdgAllBankCode("");
        setNAccountNo("");
        setNIfscCode("");
        var ldgType = "";
        if (v === "") {
            $(".loader").hide();
            return;
        }
        if (v === "CH") {
            ldgType = "CASH";
        } else if (v === "BN" || v === "CQ") {
            ldgType = "BANK";
            setLdgSrchType("BANK");
            $(".loader").hide();
            return;
        } else {
            ldgType = "WALKIN";
        }
        setLdgSrchType(ldgType);
        Common.callApi(Common.apiLedger, [sid, "getledgerinfo", ldgType], result => {
            let resp = JSON.parse(result);
            setPdAccount({ id: resp.id, label: resp.label });
            $(".loader").hide();
        });
    }


    const addPayment = () => {
        console.log("Account Value is :", pdAccount);
        var msg = [], i = 0;
        setUsdAmount(Number(usdRate) > 0 ? (pmAmount / Number(usdRate)).toFixed(2) : 0);
        if (pmInvAmount < 1) {
            msg[i++] = (pmInvAmount < 1 ? "Invoice amount must be greater than 0." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pdPaymentType === "" || pdAccount === null || pdAmount < 1 || (pdPaymentType === 'CQ' && chequeValue === null) || (pdPaymentType === "BN" && pdChequeNum === "")) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pdAccount === null ? "Account." : '');
            msg[i++] = (pdPaymentType === "" ? "Payment Type." : '');
            msg[i++] = (pdAmount < 1 ? "Entered amount can't be 0." : '');
            if (pdPaymentType === 'CQ' && chequeValue === null) msg[i++] = (chequeValue === null ? "Select a Cheque." : '');
            if (pdPaymentType === "BN" && pdChequeNum === "") msg[i++] = (chequeValue === null ? "Refernece Number." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pdPaymentType === 'PB' && (ldgAllBankCode === "" || nAccountNo === "" || nIfscCode === "")) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ldgAllBankCode === "" ? " Bank name . " : '');
            msg[i++] = (nAccountNo === "" ? "Account Number ." : '');
            msg[i++] = (nIfscCode === "" ? "IFSC Code . " : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            // Check for duplicate reference number if payment type is BN
            if (pdPaymentType === "BN" && pdChequeNum !== "") {

                const isDuplicateRef = paymentData.some(item =>
                    item.tp_payment_type === pdPaymentType &&
                    item.tp_cheque === pdChequeNum
                );

                if (isDuplicateRef) {
                    msg[i++] = `Reference number '${pdChequeNum}' is already used for '${pdPaymentType}.`;
                    setMsgText(Common.buildMessageFromArray(msg));
                    setMsgBox(true);
                    return;
                }
            }
            //validate Cash payment should only one time.
            if (pdPaymentType === "CH") {
                const isCashEntry = paymentData.some(item => item.tp_payment_type === "CH");
                if (isCashEntry) {
                    setMsgText('Only single cash entry is allowed.');
                    setMsgBox(true);
                    return;
                }
            }

            var grp = 0;
            var accnt = 0;
            var accntname = '';
            if (pdAccount !== null) {
                var a = pdAccount.id.split("^");
                grp = a[1];
                accnt = a[2];
                if (pdPaymentType === "CH" || pdPaymentType === 'PB' || pdPaymentType === 'RC') {
                    accntname = a[4];
                } else {
                    accntname = a[5];
                }
            }
            let tcbb_srno = 0;
            let tcbb_line_no = 0;
            let tcbb_location = 0;
            let tcbb_from = 0;
            let tcbb_type = '';

            if (pdPaymentType === "CQ") {
                const ch = chequeValue.id.split("^");
                tcbb_srno = ch[1];
                tcbb_line_no = ch[2];
                tcbb_location = ch[3];
                tcbb_from = ch[4];
                tcbb_type = ch[5];
            }
            const obj = {
                uniquekey: Common.getRandomString(10),
                tp_line_no: paymentLineNo + 1,
                tp_location: locationCode,
                tp_srno: srno,
                randomString: randomString,
                tp_payment_type: pdPaymentType,
                tp_account: accnt,
                tp_group: grp,
                // mvli_ledger_name: (nCorporate !== null && pdPaymentType === 'PB') ? corpName : accntname,
                mvli_ledger_name: accntname,
                tp_amount: pdAmount,

                tp_cheque: pdChequeNum,
                tp_type: "MT",
                tcbb_from: chequeNum,
                chequeValue: chequeValue,
                delny: 'Y',
                tcbb_srno: tcbb_srno,
                tcbb_line_no: tcbb_line_no,
                tcbb_location: tcbb_location,
                tcbb_from: tcbb_from,
                tcbb_type: tcbb_type,
                bank_code: ldgAllBankCode,
                accnum: nAccountNo,
                ifsc: nIfscCode,
            };
            const obj2 = {
                TabType: "Payment",
                AType: "A",
                ALineNo: tranAuditTrail.length + 1,
                TLoc: locationCode,
                TType: 'MT',
                PaymentType: pdPaymentType,
                PaymentLedgerCode: accnt,
                PaymentGroupCode: grp,
                PaymentAccountName: accntname,
                PaymentAmount: pdAmount,
                ReferenceNo: pdChequeNum,
                chequeValue: chequeValue,
                delny: 'Y',
                TcbbSrno: tcbb_srno,
                TcbbLineno: tcbb_line_no,
                TcbbLocation: tcbb_location,
                TcbbFrom: tcbb_from,
                TcbbType: tcbb_type,
                bank_code: ldgAllBankCode,
                accnum: nAccountNo,
                ifsc: nIfscCode,
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            // const existingItem = Common.isSamePaymentMethod(obj, paymentData);
            // if (existingItem) {
            //     existingItem.tp_amount = (existingItem.tp_amount * 1 || 0) + (obj.tp_amount * 1 || 0);
            //     existingItem.tcbb_from = chequeNum;
            //     existingItem.tp_cheque = pdChequeNum;
            // } else {
            const paymentdata = Common.arrayAddItem(paymentData, obj);
            setPaymentData(paymentdata);
            setPdPaymentType("");
            setPaymentLineNo((1 * paymentLineNo) + 1);
            setPdAmount("");
            setPdAccount(null);
            setChequeValue(null);
            setChequeLineNo("");
            setChequeLocation("");
            setChequeSrno("");
            setCounter(counter + 1);
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
            setPdAmount(1 * pmInvAmount - amt);
        }
    }


    const handleChequeValue = (value) => {
        setChequeValue(value);
        var id = value.id.split("^");
        setChequeSrno(id[1]);
        setChequeLineNo(id[2]);
        setChequeLocation(id[3]);
        setChequeNum(id[4]);
    }


    const handleAccountValue = (value) => {
        setPdAccount(value);
        var id = value.id.split("^");
        setPdGroupValue(id[1]);
        setPdAccountValue(id[2]);
    }


    const handleTabChange = (k) => {
        setKey(k);
        if (k === "PAYMENT") {
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
            setPdAmount(1 * pmInvAmount - amt);
        }
    }

    const switchToPaymentTab = (e) => {
        if (e.key === 'Enter') setKey("PAYMENT");
        else if (e.key === "Tab") {
            e.preventDefault();
            paymentRef.current.focus();
        }
    }

    const print = () => {
        $(".loader").show();
        const obj = {
            srno: srno,
            location: locationCode,
            type: 'FAP',
            faType: 'MT',
        }
        Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
            $(".loader").hide();
            var newWindow = window.open();
            newWindow.document.write(result);
        });
    }


    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: locationCode, trannumber: srno, type: 'MT' });
    }

    const handlePaymentBtn = () => {
        setKey("PAYMENT");
        var amt = 0;
        for (var i = 0; i < paymentData.length; i++) {
            amt += paymentData[i].tp_amount * 1;
        }
        setPdAmount(1 * pmInvAmount - amt);
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "MT", trannumber: srno, trancategory: "T", location: locationCode });
    }
    const handleAllBankChange = (value) => {
        setLdgAllBank(value);
        const allbank = value.id.split('^');
        setLdgAllBankCode(allbank[1]);
    }

    return (

        <>
            {
                showIndividualForm ?
                    <Master_individual_profile reqObj={{ nIndivual: nIndividual, scrIndividual: scrIndividual }} value="TRAN_MT" hideIndividualProfile={hideIndividualProfile} />
                    :
                    <>
                        <LoginHeader />
                        <Menu />
                        <Container fluid>
                            <Row>
                                <Col>
                                    <h3>Principle Module</h3>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            {
                                scrMode === "" ?
                                    <>
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={pmLocation}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={handleChangeLocation}
                                                        isDisabled={branchDisable === "true"}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-4 col-6'>
                                                <Form.Group>
                                                    <Row style={{ marginTop: "30px" }}>
                                                        <Col>
                                                            <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                                        </Col><Col>
                                                            <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                                        </Col><Col>
                                                            <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                                        </Col>
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            {
                                                radioType === 'N' ?
                                                    <>
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Date<span className="text-danger">*</span></Form.Label>
                                                                <DatePicker className="form-control"
                                                                    selected={pmNewDate}
                                                                    onChange={(date) => setPmNewDate(date)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    showYearDropdown
                                                                    showMonthDropdown
                                                                    useShortMonthInDropdown
                                                                    dropdownMode="select"
                                                                    peekNextMonth
                                                                    customInput={
                                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </>
                                                    :
                                                    radioType === 'S' ?
                                                        <>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                                                    <Form.Control value={pmFromSrno}
                                                                        maxLength={20}
                                                                        onChange={(e) => Common.validateNumValue(e.target.value, setPmFromSrno)}
                                                                        placeholder="From" />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>To<span className="text-danger">*</span></Form.Label>
                                                                    <Form.Control value={pmToSrno}
                                                                        maxLength={20}
                                                                        onChange={(e) => Common.validateNumValue(e.target.value, setPmToSrno)}
                                                                        placeholder="To" />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                        :
                                                        radioType === 'D' ?
                                                            <>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                        <DatePicker className="form-control"
                                                                            selected={pmFromDate}
                                                                            onChange={(date) => setPmFromDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                        <DatePicker className="form-control"
                                                                            selected={pmToDate}
                                                                            onChange={(date) => setPmToDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                            :
                                                            null
                                            }
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col>
                                                {
                                                    userRight.add === "1" && radioType === 'N' ?
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNew()}>Add New</Button> : null
                                                }
                                                &nbsp;
                                                {
                                                    userRight.query === "1" && (radioType === 'S' || radioType === 'D') ?
                                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => list()}>List</Button>
                                                        : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col>
                                                <Table striped bordered hover size="sm">
                                                    <thead>
                                                        <tr>
                                                            {userRight.query === "1" ? <th></th> : null}
                                                            <th>SrNo</th>
                                                            <th>Location</th>
                                                            <th>Date</th>
                                                            <th>Type</th>
                                                            <th>Principle</th>
                                                            <th>Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            principleData.map((res) => (
                                                                <tr key={res.tpm_srno}>
                                                                    {userRight.query === "1" ?
                                                                        <td className="textCenter">
                                                                            <span className="handCursor colorThemeBlue" onClick={() => viewList(res.tpm_srno, res.tpm_location, res.tpm_type, res.tpm_date)}>
                                                                                <FontAwesomeIcon icon={faEye} />
                                                                            </span>
                                                                        </td>
                                                                        : null
                                                                    }
                                                                    <td>{res.tpm_srno}</td>
                                                                    <td>{res.entity_name}</td>
                                                                    <td>{res.tpm_date}</td>
                                                                    <td>{res.tpm_type}</td>
                                                                    <td>{res.pm_name}</td>

                                                                    <td>{res.tpm_amount}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </>
                                    :
                                    <>
                                        <Row>
                                            <Col>
                                                <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelConfirm()}>Back</Button>
                                                {
                                                    (userRight.edit === "1" && scrMode === "Q") ? <>
                                                        &nbsp;<Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnEditRequest()}>Edit</Button>
                                                    </> : null
                                                }
                                                {
                                                    (userRight.edit === "1" && scrMode === "E") || (userRight.add === "1" && scrMode === "A") ? <>
                                                        &nbsp;<Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>
                                                    </> : null
                                                }
                                                {

                                                    (userRight.query === "1" && scrMode === "Q") ? <>
                                                        &nbsp;<Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => print()}>Print</Button>
                                                        &nbsp;<Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>
                                                        &nbsp;<Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                                    </> : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                            <Tab eventKey="INFO" title="Info">
                                                <Row>
                                                    <Col className='col-md-6 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Master Principle<span className="text-danger">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pmPrinciple}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={Picklist.fetchPrincipleModulePicklist}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleChangePrinciple}
                                                                isDisabled={scrMode === "Q"}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-12">
                                                        <Form.Group>
                                                            <Form.Label>Beneficiary/Receiver/Individual Profile<span className="colorThemeRed">*</span>
                                                                {
                                                                    scrMode === "Q" ? null :
                                                                        <>
                                                                            <span className='tranNewFormText' onClick={() => newIndividual("A")}>Not in list? Create New</span>
                                                                            &nbsp;&nbsp;
                                                                            <span className='tranNewFormText' onClick={() => newIndividual("E")}>Edit</span>&nbsp;
                                                                        </>
                                                                }
                                                            </Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={nIndividual}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={Picklist.fetchIndividualPicklist}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleNewIndiviualChange}
                                                                isDisabled={scrMode === "Q"}
                                                                formatOptionLabel={Picklist.formatOptionLabel}
                                                                components={{ Menu: Picklist.menu }}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Ref No/PIN/ICN/MTCN <span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Control placeholder='Reference No'
                                                                maxLength={255}
                                                                value={pmRefNum}
                                                                disabled={scrMode === "Q"}
                                                                onChange={e => Common.validateAlpNumSplValue(e.target.value, setPmRefNum)} />
                                                        </Form.Group>
                                                    </Col>

                                                    {
                                                        /*
                                                                        <Col className="col-md-3 col-6">
                                                                            <Form.Group>
                                                                                <Form.Label>Other Charges<span className="colorThemeRed">*</span></Form.Label>
                                                                                <Form.Control placeholder='Other Charges'
                                                                                    maxLength={10}
                                                                                    value={pmOtherCharges}
                                                                                    disabled={scrMode === "Q"}
                                                                                    onChange={(e) => handleOtherCharges(e)}
                                                                                // onChange={e => Common.validateDecValue(e.target.value, setPmOtherCharges)} 
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                            <Col className="col-md-3 col-6">
                                                                            <Form.Group>
                                                                                <Form.Label>Invoice Amount<span className="colorThemeRed">*</span></Form.Label>
                                                                                <Form.Control placeholder='Invoice Amount'
                                                                                    maxLength={10}
                                                                                    value={pmInvAmount}
                                                                                    onChange={e => Common.validateDecValue(e.target.value, setPmInvAmount)}
                                                                                    disabled
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
 
                                                        */
                                                    }
                                                    {
                                                        principleFlag === 'P' ?
                                                            <>

                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Group>
                                                                        <Form.Label>Sender Name</Form.Label>
                                                                        <Form.Control placeholder='Sender Name'
                                                                            maxLength={100}
                                                                            value={pmSenderName}
                                                                            disabled={scrMode === "Q"}
                                                                            onChange={e => Common.validateAlpValue(e.target.value, setPmSenderName)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Group>
                                                                        <Form.Label>Order No.</Form.Label>
                                                                        <Form.Control placeholder='Order No.'
                                                                            maxLength={50}
                                                                            value={pmOrderNum}
                                                                            disabled={scrMode === "Q"}
                                                                            onChange={e => Common.validateAlpNumSplValue(e.target.value, setPmOrderNum)} />
                                                                    </Form.Group>
                                                                </Col>

                                                            </> : <>

                                                                <Col className="col-md-3 col-6"></Col>
                                                                <Col className="col-md-3 col-6"></Col>
                                                            </>
                                                    }
                                                </Row>
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Amount<span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Control placeholder='Amount'
                                                                maxLength={10}
                                                                value={pmAmount}
                                                                disabled={scrMode === "Q"}
                                                                onChange={(e) => handleAmount(e)}
                                                            // onChange={e => Common.validateDecValue(e.target.value, setPmAmount)} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Button variant='outline-secondary' className='buttonStyle' size='sm'
                                                            // onClick={() => setKey("PAYMENT")} 
                                                            onClick={handlePaymentBtn}
                                                            onKeyDown={switchToPaymentTab}>Payment-&gt;</Button>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="PAYMENT" title="Payment">
                                                <Row>
                                                    <Col><h3>Payment Details</h3></Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                {
                                                    scrMode === "Q" ? null
                                                        :
                                                        <>
                                                            <Row>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Payment Type</Form.Label>
                                                                        <Form.Select value={pdPaymentType} onChange={e => handlePaymentType(e.target.value)} ref={paymentRef}>
                                                                            <option value="">Select</option>
                                                                            <option value="CH">Cash</option>
                                                                            <option value="BN">Bank</option>
                                                                            <option value="CQ">Cheque</option>
                                                                            {
                                                                                principleFlag === 'S' ?
                                                                                    <option value="RC">Recievables</option>
                                                                                    :
                                                                                    <option value="PB">Payables</option>
                                                                            }
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Account<span className="colorThemeRed">*</span></Form.Label>
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={pdAccount}
                                                                            getOptionLabel={e => e.label + ' '}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, ldgSrchType, locationCode)} // location = 1 , 2
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={handleAccountValue}
                                                                            isDisabled={disablePaymentAccount}
                                                                        >
                                                                        </AsyncSelect>
                                                                    </Form.Group>
                                                                </Col>
                                                                {
                                                                    pdPaymentType !== "" ?
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>Amount</Form.Label>
                                                                                <Form.Control placeholder='Amount' value={pdAmount} onChange={e => Common.validateDecValue(e.target.value, setPdAmount)} />
                                                                            </Form.Group>
                                                                        </Col> : null
                                                                }
                                                            </Row>
                                                            {
                                                                pdPaymentType === "BN" ?
                                                                    <Row>
                                                                        <Col className="col-md-12">
                                                                            <Form.Group>
                                                                                <Form.Label>Reference No<span className="colorThemeRed">*</span></Form.Label>
                                                                                <Form.Control placeholder='Reference No' maxLength={255} value={pdChequeNum} onChange={e => Common.validateAlpNumSplValue(e.target.value, setPdChequeNum)} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    : pdPaymentType === "PB" ?
                                                                        <Row>

                                                                            <Col className="col-md-3 col-6">
                                                                                <Form.Label>Bank Name</Form.Label>
                                                                                <AsyncSelect
                                                                                    cacheOptions={false}
                                                                                    defaultOptions={false}
                                                                                    value={ldgAllBank}
                                                                                    getOptionLabel={e => e.label + ' '}
                                                                                    getOptionValue={e => e.id}
                                                                                    loadOptions={Picklist.fetchAllBankPicklist}
                                                                                    onInputChange={Picklist.handleInputChange}
                                                                                    onChange={handleAllBankChange}
                                                                                    isDisabled={scrMode === "Q"}
                                                                                >
                                                                                </AsyncSelect>
                                                                            </Col>
                                                                            <Col className="col-md-3 col-6">
                                                                                <Form.Group>
                                                                                    <Form.Label>Account Number <span className="colorThemeRed">*</span></Form.Label>
                                                                                    <Form.Control disabled={scrMode === "Q"} placeholder='Account' type='text' maxLength={250} value={nAccountNo}
                                                                                        onChange={e => Common.validateAlpNumValue(e.target.value, setNAccountNo)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col className="col-md-3 col-6">
                                                                                <Form.Group>
                                                                                    <Form.Label>IFSC No <span className="colorThemeRed">*</span></Form.Label>
                                                                                    <Form.Control disabled={scrMode === "Q"} placeholder='Account' type='text' maxLength={250} value={nIfscCode}
                                                                                        onChange={e => Common.validateAlpNumValue(e.target.value, setNIfscCode)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row> : pdPaymentType === "CQ" ?
                                                                            <Row>
                                                                                <Col className="col-md-3 col-6">
                                                                                    <Form.Group>
                                                                                        <Form.Label>Cheque No<span className="colorThemeRed">*</span></Form.Label>
                                                                                        <AsyncSelect
                                                                                            cacheOptions={false}
                                                                                            defaultOptions={false}
                                                                                            value={chequeValue}
                                                                                            getOptionLabel={e => e.label + ' '}
                                                                                            getOptionValue={e => e.id}
                                                                                            loadOptions={(search) => Picklist.fetchChequeBookBankPicklist(search, pdGroupValue, pdAccountValue, locationCode)}
                                                                                            onInputChange={Picklist.handleInputChange}
                                                                                            onChange={handleChequeValue}
                                                                                        >
                                                                                        </AsyncSelect>
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Row>
                                                                            : null
                                                            }
                                                            <Row>&nbsp;</Row>
                                                            <Row>
                                                                <Col>
                                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => addPayment()}>Add</Button>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                }
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Table responsive striped bordered>
                                                        <thead>
                                                            <tr>
                                                                <th>&nbsp;</th>
                                                                <th>Type</th>
                                                                <th>Group</th>
                                                                <th>Account</th>
                                                                <th>Name</th>
                                                                <th>Amount</th>
                                                                <th>USD Rate</th>
                                                                <th>USD Amount</th>
                                                                <th>Cheque</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                paymentData.map((item, index) => (
                                                                    <>
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {
                                                                                    scrMode !== "Q" && item.delny === "Y" ?
                                                                                        <span className='colorThemeBlue pointer' onClick={() => deletePayment(item)}>
                                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                                        </span> : null
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    item.tp_payment_type === "BN"
                                                                                        ? "Bank" : item.tp_payment_type === "CQ"
                                                                                            ? "Cheque" : item.tp_payment_type === "CH"
                                                                                                ? "Cash" : item.tp_payment_type === "RC"
                                                                                                    ? "Receivables" : item.tp_payment_type === "PB"
                                                                                                        ? "Payables" : ""
                                                                                }
                                                                            </td>
                                                                            <td>{item.tp_group}</td>
                                                                            <td>{item.tp_account}</td>
                                                                            <td>{item.mvli_ledger_name}</td>
                                                                            <td>{item.tp_amount}</td>
                                                                            <td>{usdRate}</td>
                                                                            <td>{usdRate > 0 && parseFloat(item.tp_amount) > 0 ? (parseFloat(item.tp_amount) / usdRate).toFixed(2) : 0}</td>
                                                                            <td>{item.tp_payment_type === "BN" ? item.tp_cheque : item.tp_payment_type === "CQ" ? item.tcbb_from : ''}</td>
                                                                        </tr>
                                                                        <tr key={`hi+${index}`} >
                                                                            <td colSpan={15}>
                                                                                Bank Code : {item.bank_code} , Account no : {item.accnum} , IFSC : {item.ifsc}
                                                                            </td >
                                                                        </tr>
                                                                    </>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Row>
                                            </Tab>
                                        </Tabs>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col>
                                                <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelConfirm()}>Back</Button>{' '}
                                                {
                                                    (userRight.edit === "1" && scrMode === "Q") ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnEditRequest()}>Edit</Button> &nbsp;
                                                    </> : null
                                                }
                                                {
                                                    (userRight.edit === "1" && scrMode === "E") || (userRight.add === "1" && scrMode === "A") ? <>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>
                                                    </> : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                    </>
                            }
                        </Container>
                    </>
            }
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <div>
                <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
                <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
                <Dialog isOpen={isErrBox} onClose={(e) => setErrBox(false)}>
                    {errText}
                </Dialog>

                <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />

            </div>
        </>
    )
}

export default Tran_principle_module;